var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg62PlacementSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_88415",
    "data-name": "Group 88415",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 441.633,
    height: 372.119,
    viewBox: "0 0 441.633 372.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25935",
    "data-name": "Rectangle 25935",
    width: 441.634,
    height: 372.12,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88414",
    "data-name": "Group 88414",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309719",
    "data-name": "Path 309719",
    d: "M394.621,100.966,248.17,223.486l-77.055-65.642c-14.422,12.7-36.694,32.3-59.1,51.972C96.7,223.261,84.3,234.122,74.255,242.913L4.267,242.83c19.41-16.521,97.554-85.191,150.2-131.6l16.1-14.19L248.456,163.4,362.783,67.752Z",
    transform: "translate(7.936 126.007)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309720",
    "data-name": "Path 309720",
    d: "M123.148,68.961,192.9,138.923,212.6,59Z",
    transform: "translate(229.033 109.729)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309721",
    "data-name": "Path 309721",
    d: "M41.944,132.526a110.608,110.608,0,0,0-1.287-13.653c-.921-5.331-1.75-8.4-1.762-8.431-.12-.469-1.873-2.365-5.774-2.308s-3.532,2.548-3.532,2.548a.823.823,0,0,0,.029.22,119.484,119.484,0,0,1,3.463,29.874c0,.234-.029.643-.011.912,0,0,9.037.234,9.04,0,.315-1.464.163-5.525-.166-9.163",
    transform: "translate(55.015 201.109)",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309722",
    "data-name": "Path 309722",
    d: "M42.425,140.694c0,.234-.126.42-.277.42h0c-.149,0-.269-.192-.272-.42H34.126c0,.234-.126.42-.275.42h-.006c-.152,0-.275-.2-.272-.432a116.7,116.7,0,0,0-.643-13.235,103.815,103.815,0,0,0-2.96-16.544.823.823,0,0,1-.029-.22s-.369-2.488,3.532-2.548,5.654,1.839,5.777,2.308c.006.026.478,1.762,1.1,4.885.209,1.032.432,2.219.661,3.546A111.257,111.257,0,0,1,42.3,132.526a35.171,35.171,0,0,1,.129,8.168",
    transform: "translate(55.67 201.109)",
    fill: "#e5e5e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309723",
    "data-name": "Path 309723",
    d: "M31.007,121.28H61.378s-.706-2.863-18.3-2.437c-12.446.3-12.074,2.437-12.074,2.437",
    transform: "translate(57.665 220.947)",
    fill: "#dededf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309724",
    "data-name": "Path 309724",
    d: "M30.142,149.273c3.52-17.825,2.617-28.767,2.611-28.9-.009-.275.5-.523.769-.532s1.49-.08,1.633.154c.183.306.892,13.784-4.356,29.282Z",
    transform: "translate(56.059 222.847)",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309725",
    "data-name": "Path 309725",
    d: "M43.406,149.273c-3.52-17.825-2.617-28.767-2.611-28.9.009-.275-.5-.523-.769-.532s-1.49-.08-1.633.154c-.183.306-.892,13.784,4.356,29.282Z",
    transform: "translate(71.15 222.847)",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309726",
    "data-name": "Path 309726",
    d: "M45.371,149.273c-3.52-17.825-2.617-28.767-2.611-28.9.009-.275-.5-.523-.769-.532s-1.49-.08-1.633.154c-.183.306-.892,13.784,4.356,29.282Z",
    transform: "translate(74.805 222.847)",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309727",
    "data-name": "Path 309727",
    d: "M32.12,149.273c3.52-17.825,2.617-28.767,2.611-28.9-.009-.275.5-.523.769-.532s1.49-.08,1.633.154c.183.306.892,13.784-4.356,29.282Z",
    transform: "translate(59.737 222.847)",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309728",
    "data-name": "Path 309728",
    d: "M61.584,121.061H31.621a.826.826,0,0,1,0-1.653H61.584a.826.826,0,0,1,0,1.653",
    transform: "translate(57.273 222.078)",
    fill: "#d5d5d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309729",
    "data-name": "Path 309729",
    d: "M42.394,111.818l10.1-2.188.595,1.45s-11.139,6.629-12.183,6.3,1.493-5.565,1.493-5.565",
    transform: "translate(75.6 203.892)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309730",
    "data-name": "Path 309730",
    d: "M38.2,131.595a.9.9,0,0,0-.16.958l0,.006a5.937,5.937,0,0,0,1.885,2.068c.112.092.214.174.3.252a.738.738,0,0,1,.069.06l.051.049c.829.764.518.938,2,2.488,1.7,1.764,2.866,1.8,3.2,1.636.28-.137-.289-1.075-.924-2.128l-.092-.152-.252-.423c-.741-1.267-.552-1.862-.375-3.746.143-1.53,2.382-8.554,2.382-8.554l-3.252-.561s-.978,5.594-2.056,6.455c-.578.46-1.224.466-1.779.806-.037.023-.077.046-.114.071a4.265,4.265,0,0,0-.889.715",
    transform: "translate(70.616 229.775)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309731",
    "data-name": "Path 309731",
    d: "M38.2,126.872a.9.9,0,0,0-.16.958l0,.006a6.908,6.908,0,0,0,1.887,2.062c.112.092.212.177.3.257a.738.738,0,0,1,.069.06l.051.049c.829.764.518.938,2,2.488,1.7,1.764,2.866,1.8,3.2,1.636.28-.137-.289-1.075-.924-2.128a7.232,7.232,0,0,1-3.023-2.228c-1.021-1.3-1.7-2.977-2.4-3.947-.037.023-.077.046-.114.071a4.265,4.265,0,0,0-.889.715",
    transform: "translate(70.616 234.497)",
    fill: "#5f6063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309732",
    "data-name": "Path 309732",
    d: "M48.907,130.208c.2,1,1.63.835,3.229.446s1.218.074,3.495-.177,2.963-1.1,3.031-1.438c.063-.3-1.061-.406-2.268-.546-.152-.017-.3-.034-.455-.054-1.361-.172-2.359-1.05-3.595-1.77-1.17-.683-2.917-3.466-2.917-3.466l-3.12.246s1.636,2.488,2.271,3.569a3.776,3.776,0,0,1,.306,2.125,3.925,3.925,0,0,0,.023,1.067",
    transform: "translate(86.123 229.132)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309733",
    "data-name": "Path 309733",
    d: "M50.476,127.212c1.6-.392,1.218.074,3.492-.177s2.966-1.1,3.034-1.439c.063-.3-1.061-.406-2.268-.546l-.011.026a6.418,6.418,0,0,1-3.257,1.012c-1.541.037-3.177-.406-4.244-.389a4.041,4.041,0,0,0,.026,1.067c.2,1,1.63.838,3.229.446",
    transform: "translate(87.782 232.571)",
    fill: "#5f6063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309734",
    "data-name": "Path 309734",
    d: "M44.789,111.037s.744-1.822,1.561-1.9,3.417-.483,3.6-.112a2.573,2.573,0,0,1-.558,2.193c-.558.483-4.012,1.264-4.012,1.264Z",
    transform: "translate(83.3 202.488)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309735",
    "data-name": "Path 309735",
    d: "M50,121.928l-6.723,18.091a6.136,6.136,0,0,1-2.022-.186,8.636,8.636,0,0,1-1.956-.949s1.667-17.373,4.724-20.985S50,121.928,50,121.928",
    transform: "translate(73.08 217.464)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309736",
    "data-name": "Path 309736",
    d: "M36.157,119.587s19.318-6.532,23.625-5.142,17.242,27.125,17.242,27.125a2.486,2.486,0,0,1-1.087.686,10.311,10.311,0,0,1-2.537.26s-11.674-10.007-13.064-12.924-1.945-5.7-3.335-5.419-17.928,6.809-21.68,2.917a10.823,10.823,0,0,1-2.768-8.946Z",
    transform: "translate(60.328 212.487)",
    fill: "#5f6063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309737",
    "data-name": "Path 309737",
    d: "M48.016,100.5a4.7,4.7,0,0,0-2.537-.486,1.174,1.174,0,0,1,.535-.252,3.908,3.908,0,0,0-1.4.366c-6.037-2.328-6.987,6.563-6.861,8.628s.143,4.441-2.871,6.294c-5.928,3.643-.927,10.007-.927,10.007.046.026,2.76,4.627,2.76,4.627-.154-1.67,7.547-10.476,11.565-13.115a11.577,11.577,0,0,0,1.35-4.181,10.975,10.975,0,0,1-.821,3.784c3.4-3.131,1.421-14.413-.792-15.672",
    transform: "translate(59.482 185.512)",
    fill: "#fda02a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309738",
    "data-name": "Path 309738",
    d: "M41.3,109.545a5.568,5.568,0,0,1-3.415.623,4.439,4.439,0,0,1-2.274-2.179c.589-.117.758-.924.744-4.393l.266.051,4.464.887s-.1,1.4-.1,2.725c-.006,1.112.063,2.168.317,2.285",
    transform: "translate(66.226 192.672)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309739",
    "data-name": "Path 309739",
    d: "M40.426,104.5s-.1,1.4-.106,2.728c-2.5-.071-3.818-2.348-4.358-3.612Z",
    transform: "translate(66.883 192.707)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309740",
    "data-name": "Path 309740",
    d: "M36.882,109.411a13.115,13.115,0,0,1-1.624-3.838c-.223-1.261.42-5.943,5.122-5.268a6.394,6.394,0,0,1,2.651,1c1.021.692,2.494,2.179.847,6.263l-.426,1.381Z",
    transform: "translate(65.502 186.426)",
    fill: "#fda02a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309741",
    "data-name": "Path 309741",
    d: "M41.7,110.848s-5.908.1-5.914-3.583-.769-6.149,3-6.366,4.51,1.187,4.81,2.414-.363,7.416-1.9,7.536",
    transform: "translate(66.44 187.612)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309742",
    "data-name": "Path 309742",
    d: "M42.72,101.339s-1.619,4.318-4.1,4.956-3.56-.026-3.56-.026a7.029,7.029,0,0,0,2.3-4.155s4.141-2.831,5.362-.775",
    transform: "translate(65.203 187.08)",
    fill: "#fda02a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309743",
    "data-name": "Path 309743",
    d: "M37.6,101.433a5.212,5.212,0,0,1,1.5,1.9c.295.938.426,2.866.989,2.8,0,0,1.218-2.937-.152-4.6-1.453-1.759-2.342-.106-2.342-.106",
    transform: "translate(69.926 187.338)",
    fill: "#fda02a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309744",
    "data-name": "Path 309744",
    d: "M34.645,122.591c-.583-2.445,1.4-7.187,3.469-11.113,1.879-3.558,3.829-6.446,4-6.343,4.953,2.94,5.4.5,5.4.5s4.5.6,5.774,2.788c1.581,2.723,3.289,10.324,4.985,11.765a3.2,3.2,0,0,0,.126,2.208c.06.212.126.412.2.6a11.334,11.334,0,0,0,.852,1.747c-.864.523-2.528,1.521-3.755.8-1.87-1.092-3.329-4.424-4.15-5.751l-.009-.014c-1.785,10.1.643,12.4-.586,13.467-1.3,1.124-3.152-.538-7.227,1.23-2.674,1.161-6.386,2.837-8.883,3.129-1.31.154-2.288-.074-2.605-.958-.927-2.571,3.52-9.4,2.408-14.059",
    transform: "translate(59.717 195.527)",
    fill: "#5f6063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309745",
    "data-name": "Path 309745",
    d: "M37.355,103.777s.112.469,1.273.395c0,0,.978-.06.947-.575a3.152,3.152,0,0,0-2.219.18",
    transform: "translate(69.474 192.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309746",
    "data-name": "Path 309746",
    d: "M32.237,129.56c.317.884,1.3,1.112,2.605.958,1.73-.752,9.2-3.646,9.114-5.605-.123-2.9-1.436-3-.509-6.58.744-2.877-6.157-8.225-7.258-9.389-2.068,3.927-2.125,4.112-1.544,6.558,1.112,4.659-3.335,11.488-2.408,14.059",
    transform: "translate(59.717 202.616)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309747",
    "data-name": "Path 309747",
    d: "M32.246,126.178a10.967,10.967,0,0,1,3.612-3.337c-.209-.538,5.571-7.624,5.571-8.722s1.541-8.986,1.541-8.986-4.816.3-6.483,2.622c-2.085,2.908-6.415,14.1-4.241,18.423",
    transform: "translate(58.865 195.529)",
    fill: "#5f6063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309748",
    "data-name": "Path 309748",
    d: "M35.511,111.325l9.623,2.511-.9,1.622s-11.714-.08-12.334-.8,3.612-3.337,3.612-3.337",
    transform: "translate(59.212 207.045)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309749",
    "data-name": "Path 309749",
    d: "M38.907,110.26c.821,1.327,2.279,4.659,4.15,5.751,1.227.718,2.891-.28,3.752-.8a11.613,11.613,0,0,1-.849-1.747c-.689.157-1.53.357-2.071.52-1.052.32-4.982-3.721-4.982-3.721",
    transform: "translate(72.36 205.064)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309750",
    "data-name": "Path 309750",
    d: "M37.075,112.649s3.023-.855,3.744-.655,3.186,1.833,2.84,2.276-2.522-.266-3.52-.132-1.773.629-2.494.52a8.283,8.283,0,0,1-1.473-.389Z",
    transform: "translate(67.272 208.232)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309751",
    "data-name": "Path 309751",
    d: "M36.487,113a11.369,11.369,0,0,0,1.9-1.193.116.116,0,0,1,.183.023c.114.177.22.521-.3.861a2.783,2.783,0,0,1-1.782.309",
    transform: "translate(67.859 207.88)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309752",
    "data-name": "Path 309752",
    d: "M50.542,114.421H36.44a1.124,1.124,0,0,1,1.124-1.124H50.542Z",
    transform: "translate(67.772 210.712)",
    fill: "#febe6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309753",
    "data-name": "Path 309753",
    d: "M44.85,108.32h21.8l-5.228,15.357H39.479Z",
    transform: "translate(73.424 201.455)",
    fill: "#febe6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309754",
    "data-name": "Path 309754",
    d: "M66.763,108.32l-5.231,15.357H39.592l5.371-15.357Z",
    transform: "translate(73.633 201.455)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309755",
    "data-name": "Path 309755",
    d: "M46.383,111.645a1.415,1.415,0,0,1-1.307,1.061.818.818,0,0,1-.818-1.061,1.415,1.415,0,0,1,1.307-1.061.818.818,0,0,1,.818,1.061",
    transform: "translate(82.26 205.667)",
    fill: "#ffedd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309756",
    "data-name": "Path 309756",
    d: "M61.944,108.32l-5.231,15.357H42.183c9.626-3.286,12.189-13.3,12.618-15.357Z",
    transform: "translate(78.453 201.456)",
    fill: "#fec47a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309757",
    "data-name": "Path 309757",
    d: "M27.223,159.139a.563.563,0,0,0,.558-.458l2.74-15.52,3.938-22.321,1.1-6.243-2.805-.08-.486,3.623L28.85,143.6,26.825,158.7a.4.4,0,0,0,.4.443",
    transform: "translate(49.884 212.981)",
    fill: "#c4c4c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309758",
    "data-name": "Path 309758",
    d: "M28.726,118.14a4.018,4.018,0,0,1,2.191,2.7l1.1-6.243-2.805-.08Z",
    transform: "translate(53.425 212.981)",
    fill: "#b2b3b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309759",
    "data-name": "Path 309759",
    d: "M56.783,159.139a.568.568,0,0,1-.561-.458l-2.74-15.52L49.545,120.84l-1.1-6.243,2.805-.08.486,3.623,3.42,25.464L57.181,158.7a.4.4,0,0,1-.4.443",
    transform: "translate(90.097 212.981)",
    fill: "#c4c4c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309760",
    "data-name": "Path 309760",
    d: "M51.739,118.14a4.026,4.026,0,0,0-2.193,2.7l-1.1-6.243,2.805-.08Z",
    transform: "translate(90.097 212.981)",
    fill: "#b2b3b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309761",
    "data-name": "Path 309761",
    d: "M28.16,118.59H98.517a2.451,2.451,0,1,0,0-4.9H28.16a2.451,2.451,0,1,0,0,4.9",
    transform: "translate(47.814 211.439)",
    fill: "#b2b3b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309762",
    "data-name": "Path 309762",
    d: "M429.282,131.354H1.021a1.021,1.021,0,0,1,0-2.042H429.282a1.021,1.021,0,0,1,0,2.042",
    transform: "translate(0 240.497)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309763",
    "data-name": "Path 309763",
    d: "M111.311,109.66s-2.173,2.7-1.5,3.063,2.474,1.055,2.9.623.558-3.612.558-3.612Z",
    transform: "translate(203.993 203.948)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309764",
    "data-name": "Path 309764",
    d: "M111.715,109.676a3.2,3.2,0,0,0-1.238.769c-.349.463-1.124,1.167-.932,1.364s1.3-.669,1.3-.669Z",
    transform: "translate(203.677 203.978)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309765",
    "data-name": "Path 309765",
    d: "M118.5,97.073s-2.451,22.8-2.671,23.456c-.049.14-.24.861-.506,1.9-.386,1.481-.935,3.615-1.45,5.64-.781,3.063-1.5,5.888-1.5,5.888l-2.125-.7s-.112-11.082.438-13.636,2.3-18.231,3.18-20.342,4.63-2.208,4.63-2.208",
    transform: "translate(205.024 180.538)",
    fill: "#cdcdce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309766",
    "data-name": "Path 309766",
    d: "M121.62,126.421l-13.361-3.5a3.282,3.282,0,0,1-2.334-3.992l1.519-5.788a3.282,3.282,0,0,1,3.992-2.334l13.361,3.5a3.278,3.278,0,0,1,2.331,3.992l-1.519,5.788a3.278,3.278,0,0,1-3.989,2.334",
    transform: "translate(196.804 205.878)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309767",
    "data-name": "Path 309767",
    d: "M108.072,114.118l-1.536,5.857a3.286,3.286,0,0,0,.8,3.089,3.177,3.177,0,0,0,.878.661l0,0a3.316,3.316,0,0,0,.666.255l13.335,3.5a3.293,3.293,0,0,0,4.007-2.342l1.536-5.857a3.293,3.293,0,0,0-2.342-4.007l-4.593-1.2.329-1.25a1.084,1.084,0,0,0-.772-1.321l-.5-.132-2.794-.732-.695-.183a1.086,1.086,0,0,0-1.321.772l-.326,1.25-2.662-.7c-.1-.026-.209-.049-.315-.066h0a3.285,3.285,0,0,0-2.854.947,3.234,3.234,0,0,0-.832,1.461m12.094-.22-4.773-1.25.329-1.25a.4.4,0,0,1,.492-.289l1.2.315,2.2.575.595.157a.389.389,0,0,1,.112.049.407.407,0,0,1,.177.443Z",
    transform: "translate(197.94 205.356)",
    fill: "#fda02a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309768",
    "data-name": "Path 309768",
    d: "M112.468,112.09s.592-1,.372-1.347-1.024,1.035-1.024,1.035.546-1.19.343-1.384-1.041,1.17-1.041,1.17.52-1.155.337-1.2-.8.972-.8.972.323-.864.026-.824-.932.832-.932.832Z",
    transform: "translate(204.106 205.264)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309769",
    "data-name": "Path 309769",
    d: "M113.685,112.864c-.386,1.484-.929,3.615-1.447,5.642a21.794,21.794,0,0,1-1.024-4.473c-.492-3.775,1.021-11.817,1.021-11.817Z",
    transform: "translate(206.655 190.105)",
    fill: "#bfbfc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309770",
    "data-name": "Path 309770",
    d: "M122.722,109.332a18.988,18.988,0,0,1,2.662,2.525,13.018,13.018,0,0,1,.99,3.543c-.04.718-1.816-1.642-2.336-1.83s.543.967.423,1.215-1.23-.563-1.653-.829-.724-2.065-1.353-3.043,1.267-1.582,1.267-1.582",
    transform: "translate(225.645 203.338)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309771",
    "data-name": "Path 309771",
    d: "M110.946,133.695h11.808c.844-.575-.229-6.183-.229-6.183s-3.223-1.224-3.778,1.264-4.107,3.274-5.986,3.578a2.017,2.017,0,0,0-1.816,1.341",
    transform: "translate(206.34 236.589)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309772",
    "data-name": "Path 309772",
    d: "M117.07,133.695h11.811c.844-.575-.229-6.183-.229-6.183s-3.223-1.224-3.781,1.264-4.107,3.274-5.983,3.578a2.022,2.022,0,0,0-1.819,1.341",
    transform: "translate(217.729 236.589)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309773",
    "data-name": "Path 309773",
    d: "M112.057,110.063s.532,6.623,1.155,14.582c.847,10.816,3.134,37.627,3.134,37.627s1.5,1.281,4.822.581a105.2,105.2,0,0,0,3.669-19.807c.014-.172.026-.346.04-.52.784-10.747,2.01-33.38,2.01-33.38Z",
    transform: "translate(208.406 202.99)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309774",
    "data-name": "Path 309774",
    d: "M111.993,108.666s.712,8.911,1.336,16.873l11.628,18.4c.014-.172.026-.346.04-.52.786-10.747,2.008-33.38,2.008-33.38Z",
    transform: "translate(208.287 202.099)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309775",
    "data-name": "Path 309775",
    d: "M113.178,111.3s8.434,20.991,11.13,28.95c1.919,5.668,7.335,25.552,7.335,25.552a5.439,5.439,0,0,0,4.335-.669s2.013-20.316-2.056-26.044c-2.159-3.037-.538-31.59-9.292-31.836s-11.454,4.047-11.454,4.047",
    transform: "translate(210.491 199.461)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309776",
    "data-name": "Path 309776",
    d: "M132.358,132.319c-3.518,1.985-18.58,1.939-19.278.383-1.559-3.478-1.95-21.148-1.215-26.568,0,0,.38-8.328,1.215-7.962,5.562-2.557,14.571-.234,14.571-.234,2.428.715,2.219,6.266,2.9,14.059.089,1,.183,2.051.292,3.132.48,4.813,1.178,10.341,2.236,16.172.071.383-.194.724-.718,1.018",
    transform: "translate(207.383 180.351)",
    fill: "#cdcdce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309777",
    "data-name": "Path 309777",
    d: "M119.607,100.978c-.094,1.49-2.036,1.321-4.373.786s-1.49-1.908-1.49-1.908.034-1.061.183-2.328c.054-.46.12-.952.209-1.427.04-.235.086-.463.14-.686.306-1.31,4.667-.046,4.636.309-.086.949.6,4.084.695,5.254",
    transform: "translate(211.266 176.376)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309778",
    "data-name": "Path 309778",
    d: "M114.066,99.231l-.186-2.059,2.588.489-1,1.839Z",
    transform: "translate(211.798 180.722)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309779",
    "data-name": "Path 309779",
    d: "M114.67,96.251,113.126,98.6a3.419,3.419,0,0,0,1.341,2.494l2.111-1.968s-1.364-.521-1.907-2.877",
    transform: "translate(210.394 179.01)",
    fill: "#bfbfc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309780",
    "data-name": "Path 309780",
    d: "M114.333,98.884a5.534,5.534,0,0,0,1.284,2.294s3.3-.889,4.087-2.58l-1.719-2.216s-.083,1.676-3.652,2.5",
    transform: "translate(212.639 179.253)",
    fill: "#bfbfc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309781",
    "data-name": "Path 309781",
    d: "M118.72,95.787a8.1,8.1,0,0,1-5.01,1.064c.054-.46.123-.949.212-1.427.575-.14,1.055-.226,1.055-.226Z",
    transform: "translate(211.48 177.051)",
    fill: "#fec781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309782",
    "data-name": "Path 309782",
    d: "M120.937,100.117c-1.027,2.826-4.773,2.1-6.366,1.65-.452-.126-.729-.232-.729-.232-.492-.226-.643-1.084-.6-2.171a16.734,16.734,0,0,1,1.421-5.92c.732-1.1,1.956-2.219,5.588-.661s2,3.712.686,7.333",
    transform: "translate(210.596 171.134)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309783",
    "data-name": "Path 309783",
    d: "M123.433,99.977c-1.147.935-3.612,2.665-3.612,2.665a4.486,4.486,0,0,0,.612-1.255,1.27,1.27,0,0,0,.043-.426,2.359,2.359,0,0,1,.337-1.307c.152-.243.206-.495.014-.675-.312-.295-.844-.023-1.19.215a.708.708,0,0,1-.769.02l-.006,0c-.978-.615.1-1.7-.692-2.594s-4.244-1.018-4.107-1.581c-1.175-.666-.435-3.117-.415-3.249a12.742,12.742,0,0,0,3.8-.377,5.61,5.61,0,0,1,4.2,1.124.965.965,0,0,0-.094-.42.887.887,0,0,1,.255.555c.026.029.037.046.029.051a1.122,1.122,0,0,1,.541.123s-.146-.046-.215.043l-.029.023c2.291,1.616,2.256,6.292,1.3,7.069",
    transform: "translate(210.906 169.824)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309784",
    "data-name": "Path 309784",
    d: "M115.187,95.1s-.183.355-1.11.06c0,0-.778-.246-.649-.658a2.616,2.616,0,0,1,1.759.6",
    transform: "translate(210.93 175.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309785",
    "data-name": "Path 309785",
    d: "M115.269,97.892s-2.062,26.076-2.033,28.246,2.285,4.47,2.285,4.47a9.551,9.551,0,0,0,2.151-4.047c.352-2.079-1-28.4-1-28.4Z",
    transform: "translate(210.597 182.062)",
    fill: "#68686b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309786",
    "data-name": "Path 309786",
    d: "M117.152,97.311s3.332.8,5.966,5.857,4.713,15.26,5.968,17.954,2.119,11.173,2.119,11.173l-1.99.975s-4.8-8.691-5.517-11.542c-.383-1.541-6.26-13.884-6.26-13.884Z",
    transform: "translate(217.882 180.981)",
    fill: "#cdcdce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309787",
    "data-name": "Path 309787",
    d: "M121.792,123.473h0c-6.272-.9-4.476-21.66-3.984-21.743s2.3,3.712,2.3,3.712l.172.841c.48,4.813,1.178,10.341,2.236,16.172.072.383-.194.724-.718,1.018",
    transform: "translate(217.949 189.197)",
    fill: "#bfbfc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309788",
    "data-name": "Path 309788",
    d: "M152.313,125.923s2.611,2.382,2.1,4.075-2.866,2.823-3.186,4.893-1.59,3.2-2.737,3.2h-5.468s-.844-1.456,1.2-1.893,2.805-2.871,2.68-5.131a39.514,39.514,0,0,1,.192-5.268l4.33-1Z",
    transform: "translate(265.678 232.093)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309789",
    "data-name": "Path 309789",
    d: "M144.94,128.708s.469,5.425-.678,5.988l-14.671-.031s0-1.693,2.356-2.068,6.495-1.756,7.2-4.83,5.8.941,5.8.941",
    transform: "translate(241.016 235.47)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309790",
    "data-name": "Path 309790",
    d: "M130.626,101.411s.775,9.506,1.684,20.934c1.235,15.526,2.723,34.592,2.868,38.2.255,6.274,1.275,16.307,1.275,16.307s2.419,2.385,7.261,1.381a162.054,162.054,0,0,0,5.545-29.479c.02-.249.04-.5.057-.749,1.147-15.429,2.931-47.916,2.931-47.916Z",
    transform: "translate(242.941 186.155)",
    fill: "#68686b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309791",
    "data-name": "Path 309791",
    d: "M130.626,101.411s.775,9.506,1.684,20.934l16.95,26.413c.02-.249.04-.5.057-.749,1.147-15.429,2.931-47.916,2.931-47.916Z",
    transform: "translate(242.941 186.155)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309792",
    "data-name": "Path 309792",
    d: "M131.862,104.986s13.947,34.429,23.122,50.61,12.037,20.7,12.037,20.7,5.253-2.071,5.731-3.48c0,0-3.506-31.238-9.649-38.854-3.469-4.3-6.463-13.847-6.314-18.366.26-7.79-2.665-16.816-2.665-16.816Z",
    transform: "translate(245.24 183.708)",
    fill: "#68686b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309793",
    "data-name": "Path 309793",
    d: "M129.954,101.125s-2.605,3.526-2.8,4.467a18.57,18.57,0,0,0-.1,5.285c.312.984,1.933-2.934,2.591-3.386s-.409,1.541-.154,1.845,1.51-1.224,2-1.747.263-3.131.789-4.719-2.331-1.745-2.331-1.745",
    transform: "translate(236.009 188.074)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309794",
    "data-name": "Path 309794",
    d: "M139.875,83.206s-3.52,32.762-3.835,33.7c-.069.2-.346,1.238-.732,2.731-.555,2.131-1.338,5.193-2.079,8.1-1.121,4.4-2.328,8.2-2.328,8.2a3.093,3.093,0,0,1-1.813.234,1.917,1.917,0,0,1-1.347-.821s.126-16.087.909-19.753,3.3-26.19,4.573-29.224,6.652-3.172,6.652-3.172",
    transform: "translate(237.576 154.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309795",
    "data-name": "Path 309795",
    d: "M132.788,105.889c-.555,2.131-1.336,5.193-2.079,8.1a31.542,31.542,0,0,1-1.47-6.426c-.709-5.422,1.464-16.973,1.464-16.973Z",
    transform: "translate(240.096 168.491)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309796",
    "data-name": "Path 309796",
    d: "M159.615,133.84c-5.053,2.851-26.694,2.785-27.7.549-2.239-5-2.8-30.38-1.744-38.164,0,0,.549-11.965,1.744-11.439,7.993-3.672,20.934-.337,20.934-.337,3.489,1.03,3.189,9,4.164,20.2q.184,2.166.42,4.5c.686,6.912,1.69,14.854,3.212,23.233.1.552-.283,1.038-1.032,1.461",
    transform: "translate(241.141 154.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309797",
    "data-name": "Path 309797",
    d: "M141.294,88.814c-.134,2.139-2.926,1.9-6.283,1.133s-2.139-2.745-2.139-2.745.049-1.519.26-3.343c.08-.661.174-1.367.3-2.05.057-.335.126-.663.2-.984.438-1.882,6.7-.066,6.661.443-.123,1.367.867,5.866,1,7.547",
    transform: "translate(246.718 148.765)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309798",
    "data-name": "Path 309798",
    d: "M133.335,86.3l-.266-2.957,3.718.7-1.43,2.64Z",
    transform: "translate(247.484 155.012)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309799",
    "data-name": "Path 309799",
    d: "M134.2,82.025,131.984,85.4a4.914,4.914,0,0,0,1.925,3.583l3.037-2.828s-1.965-.746-2.743-4.132",
    transform: "translate(245.467 152.552)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309800",
    "data-name": "Path 309800",
    d: "M133.719,85.808a7.949,7.949,0,0,0,1.845,3.295s4.742-1.275,5.868-3.7l-2.468-3.186s-.12,2.408-5.245,3.595",
    transform: "translate(248.693 152.902)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309801",
    "data-name": "Path 309801",
    d: "M140.021,81.358a11.643,11.643,0,0,1-7.2,1.53c.08-.663.174-1.367.3-2.051.824-.2,1.516-.326,1.516-.326Z",
    transform: "translate(247.027 149.738)",
    fill: "#fec781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309802",
    "data-name": "Path 309802",
    d: "M143.207,87.58c-1.476,4.058-6.855,3.023-9.149,2.371-.643-.183-1.044-.335-1.044-.335-.709-.32-.927-1.559-.864-3.117.12-3.091,1.341-7.453,2.042-8.5,1.052-1.581,2.808-3.192,8.03-.952s2.874,5.336.984,10.536",
    transform: "translate(245.758 141.237)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309803",
    "data-name": "Path 309803",
    d: "M146.792,87.378c-1.647,1.344-5.188,3.829-5.188,3.829a6.357,6.357,0,0,0,.875-1.8,1.847,1.847,0,0,0,.066-.612,3.374,3.374,0,0,1,.483-1.876c.214-.349.295-.712.02-.969-.446-.423-1.21-.034-1.71.309a1.01,1.01,0,0,1-1.1.026l-.006,0c-1.407-.881.146-2.434-1-3.723s-6.1-1.467-5.9-2.276c-1.69-.955-.626-4.478-.595-4.664a18.242,18.242,0,0,0,5.454-.543c2.459-.618,5.171.964,6.028,1.613a1.371,1.371,0,0,0-.137-.6,1.27,1.27,0,0,1,.366.8c.037.037.054.063.043.069a1.636,1.636,0,0,1,.775.18s-.209-.066-.309.06a.168.168,0,0,1-.043.031c3.292,2.325,3.243,9.04,1.876,10.158",
    transform: "translate(246.202 139.354)",
    fill: "#fda02a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309804",
    "data-name": "Path 309804",
    d: "M134.945,80.369s-.266.512-1.6.089c0,0-1.115-.357-.932-.947a3.779,3.779,0,0,1,2.528.858",
    transform: "translate(246.235 147.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309805",
    "data-name": "Path 309805",
    d: "M135.063,84.381s-2.963,37.461-2.923,40.581,3.286,6.42,3.286,6.42a13.746,13.746,0,0,0,3.089-5.814c.5-2.986-1.43-40.8-1.43-40.8Z",
    transform: "translate(245.757 156.934)",
    fill: "#68686b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309806",
    "data-name": "Path 309806",
    d: "M144.434,121.131h-.006c-9.008-1.3-6.429-31.118-5.72-31.235s3.3,5.331,3.3,5.331l.249,1.21c.686,6.912,1.69,14.854,3.212,23.233.1.552-.283,1.038-1.032,1.461",
    transform: "translate(256.322 167.187)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309807",
    "data-name": "Path 309807",
    d: "M167.254,119.939,148.2,125.484a4.714,4.714,0,0,1-5.823-3.2l-2.4-8.256a4.71,4.71,0,0,1,3.2-5.82l19.052-5.545a4.71,4.71,0,0,1,5.823,3.194l2.4,8.259a4.709,4.709,0,0,1-3.2,5.82",
    transform: "translate(259.986 190.592)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309808",
    "data-name": "Path 309808",
    d: "M140.856,114.308l2.431,8.351a4.715,4.715,0,0,0,3.26,3.22,4.579,4.579,0,0,0,1.57.166h0a4.64,4.64,0,0,0,1.009-.174l19.018-5.537a4.728,4.728,0,0,0,3.209-5.843l-2.431-8.354a4.724,4.724,0,0,0-5.843-3.206l-6.549,1.9-.518-1.782A1.555,1.555,0,0,0,154.088,102l-.718.209-3.984,1.158-.99.289a1.557,1.557,0,0,0-1.058,1.927l.518,1.782-3.8,1.1a4.318,4.318,0,0,0-.435.152h-.006a4.734,4.734,0,0,0-2.82,3.274,4.661,4.661,0,0,0,.054,2.417m14.742-9.2-6.806,1.982-.518-1.782a.585.585,0,0,1,.395-.721l1.71-.5,3.134-.912.846-.246a.624.624,0,0,1,.174-.023.586.586,0,0,1,.546.418Z",
    transform: "translate(261.618 189.579)",
    fill: "#fda02a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309809",
    "data-name": "Path 309809",
    d: "M144,102.092s-.592,4.942.518,4.87,3.818-.6,4-1.453-2.073-4.822-2.073-4.822Z",
    transform: "translate(267.513 187.262)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309810",
    "data-name": "Path 309810",
    d: "M144.709,101.175a4.6,4.6,0,0,0-.921,1.882c-.072.829-.478,2.276-.1,2.371s1.072-1.8,1.072-1.8Z",
    transform: "translate(266.942 188.167)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309811",
    "data-name": "Path 309811",
    d: "M137.768,83.546s4.784,1.147,8.568,8.414,6.772,21.923,8.577,25.793S158.1,133.23,158.1,133.23a1.782,1.782,0,0,1-1.255.786,5.828,5.828,0,0,1-1.53.1s-7.115-11.4-8.136-15.489c-.555-2.216-9-19.953-9-19.953Z",
    transform: "translate(256.224 155.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309812",
    "data-name": "Path 309812",
    d: "M18.206,132.6l-.615-4.427,2.582-2.159.812,5.863Z",
    transform: "translate(32.717 234.366)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309813",
    "data-name": "Path 309813",
    d: "M27.689,133.346H17.162a5.756,5.756,0,0,1,.3-2.823c.526-1.167,1.347-1.887,1.421-2.783a3.16,3.16,0,0,0,3.014.927,11.458,11.458,0,0,0,1.827,2.368c.686.495,3.755.317,3.967,2.311",
    transform: "translate(31.809 237.576)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309814",
    "data-name": "Path 309814",
    d: "M28.552,111.163c-.689,5.539-1.253,10.761-1.71,15.626-2.451,25.93-1.97,41.779-1.97,41.779s-.174.469-1.7.475a8.6,8.6,0,0,1-1.7-.183s-5.485-16.933-5.062-26.568a14.726,14.726,0,0,1,.429-3.117c1.316-4.93-4.87-23.782,1.853-30.8s10.172.249,9.855,2.791",
    transform: "translate(28.83 196.017)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309815",
    "data-name": "Path 309815",
    d: "M28.552,111.163c-.689,5.539-1.253,10.761-1.71,15.626l-10.427,15.5a14.726,14.726,0,0,1,.429-3.117c1.316-4.93-4.87-23.782,1.853-30.8s10.172.249,9.855,2.791",
    transform: "translate(28.83 196.017)",
    fill: "#febe6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309816",
    "data-name": "Path 309816",
    d: "M23.322,92.746s-.255-1.264-.541-2.231c-.126-.429.755-3.234,1.367-3.581s2.2,1.544,1.747,3c-.232.746-.609,3.172-.609,3.172Z",
    transform: "translate(42.348 161.607)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309817",
    "data-name": "Path 309817",
    d: "M23.919,90.736s-.332-.735-.632-.852-.621-1.318-.838-1.8c0,0,.212-.309.583.092.226.243.732.958.732.958Z",
    transform: "translate(41.751 163.616)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309818",
    "data-name": "Path 309818",
    d: "M10.186,92.129c-.066.134-.154.372-.235.595,0-.06,0-.12,0-.18,0-.446-1.667-2.871-2.351-3.023S5.947,91.64,6.8,92.9c.44.646,1.513,2.854,1.513,2.854l1.773-.915s.1-.8.355-1,.206-1.441.277-1.962c0,0-.295-.235-.532.257",
    transform: "translate(12.024 166.479)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309819",
    "data-name": "Path 309819",
    d: "M11.754,131.643c-.149-1.418-.186-5.153-.186-5.153s3.8-1.215,3.663-.38a26.971,26.971,0,0,0-.5,6.137l-1.539.918Z",
    transform: "translate(21.514 233.996)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309820",
    "data-name": "Path 309820",
    d: "M33.252,107.828s-14.7,40.289-17.591,57.766a2.924,2.924,0,0,1-1.922.306,2.138,2.138,0,0,1-1.8-1.158S9.278,143.8,14.557,136.524c3.623-4.993-1.564-26.937,6.881-28.7s11.814,0,11.814,0",
    transform: "translate(20.953 199.088)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309821",
    "data-name": "Path 309821",
    d: "M33.647,98.935v0l-.011-.051c-.086-.355-.18-.7-.28-1.05h0a23.31,23.31,0,0,0-1.067-2.96c-.229-.512-.463-.984-.7-1.4-.037-.066-.074-.126-.109-.189v0a4.236,4.236,0,0,0-1.679-1.816,5.06,5.06,0,0,0-2.768-.117,1.3,1.3,0,0,1,.529-.352,4.2,4.2,0,0,0-1.43.609c-6.769-1.516-6.375,8.062-5.914,10.232s-1.719,3.226-4.793,5.445c-5.865,4.238-5.768,8.731-5.768,8.731a1.464,1.464,0,0,1,.172.077c.235-.581.735-1.682,1.261-1.913a22.447,22.447,0,0,0-.563,2.274c.892.492,2.131,1.255,3.472,2.116h0c1.8,1.15,3.781,2.474,5.368,3.549a3.714,3.714,0,0,1-.04-1.413l.506,1.567.069.206c1.012.686,1.813,1.235,2.219,1.519.043.026.08.054.112.074l.183.126c-.134-.552.458-2,1.45-3.821q.1-.189.214-.386c.32-.575.678-1.184,1.064-1.807.137-.226.277-.452.423-.684l0,0c.117-.183.235-.369.357-.555v0c.289-.443.586-.892.889-1.341.786-1.161,1.619-2.316,2.442-3.375a29.58,29.58,0,0,1,3.352-3.758c.031-.066.063-.132.089-.2a6.674,6.674,0,0,0,.363-1.158c.029-.12.054-.243.077-.366a15.758,15.758,0,0,0,.246-2.871,16.2,16.2,0,0,1-.034,2.894c-.02.157-.04.3-.063.435a6.033,6.033,0,0,1-.18.761,3.861,3.861,0,0,0,.429-.655c.08-.157.154-.32.223-.492.792-2.025.578-5.042-.109-7.87",
    transform: "translate(17.947 169.225)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309822",
    "data-name": "Path 309822",
    d: "M21.679,100.755a5.977,5.977,0,0,1-3.523,1.2A4.756,4.756,0,0,1,15.4,100c.6-.217.658-1.1.1-4.776l.289.014,4.873.232s.114,1.507.32,2.911c.172,1.178.409,2.285.7,2.371",
    transform: "translate(28.645 177.105)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309823",
    "data-name": "Path 309823",
    d: "M20.41,95.467s.114,1.507.32,2.908c-2.66.32-4.421-1.887-5.193-3.143Z",
    transform: "translate(28.896 177.115)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309824",
    "data-name": "Path 309824",
    d: "M16.971,101.716A14.152,14.152,0,0,1,14.643,97.9c-.435-1.3-.492-6.369,4.6-6.395a6.83,6.83,0,0,1,2.968.643c1.193.569,2.989,1.916,1.887,6.506l-.237,1.533Z",
    transform: "translate(26.896 170.187)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309825",
    "data-name": "Path 309825",
    d: "M33.846,126.454a20.629,20.629,0,0,1-14.3,1.83c-.094-.023-6.558-1.052-6.558-1.052.112-.306.947-5.3,1.055-5.577,1.413-3.643,4-23.428,6.151-24.4a4.881,4.881,0,0,0,3.472.889c1.55-.137,2.071-.807,1.942-1.527,1.716.812,3.034,1.567,3.034,1.567,1.57,2.351,5.2,28.272,5.2,28.272",
    transform: "translate(24.152 179.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309826",
    "data-name": "Path 309826",
    d: "M22.479,102.459s-6.252,1.035-6.838-2.868-1.785-6.4,2.182-7.224,4.968.546,5.479,1.8.786,7.922-.824,8.291",
    transform: "translate(27.908 171.318)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309827",
    "data-name": "Path 309827",
    d: "M21.762,92.406s-1.035,4.836-3.566,5.906-3.781.532-3.781.532A7.537,7.537,0,0,0,16.2,94.076s3.944-3.658,5.562-1.67",
    transform: "translate(26.809 170.758)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309828",
    "data-name": "Path 309828",
    d: "M16.855,92.773a5.6,5.6,0,0,1,1.893,1.779c.46.949.907,2.974,1.493,2.817,0,0,.829-3.306-.887-4.85-1.819-1.639-2.5.255-2.5.255",
    transform: "translate(31.347 170.826)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309829",
    "data-name": "Path 309829",
    d: "M35.316,89.2a4.086,4.086,0,0,0-1.118-.346,3.539,3.539,0,0,0-.981.1s-1.765,10.965-1.9,11.545-7.564,8.957-9.569,8.923a9.093,9.093,0,0,0-4.353,1.636s4.215,8.914,4.424,10.587c.229,1.822,2.411,29.879,2.411,29.879s-.129,1.3,2.311.6a8.373,8.373,0,0,0,3.049-1.284s-2.242-22.086-2.711-28.956a13.126,13.126,0,0,0-.429-2.562,2.6,2.6,0,0,1,.42-2.208c3.083-4.233,7.953-11.088,8.225-12.546.4-2.142.217-15.374.217-15.374",
    transform: "translate(32.359 165.241)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309830",
    "data-name": "Path 309830",
    d: "M21.584,133.346H11.057a5.756,5.756,0,0,1,.3-2.823c.526-1.167,1.347-1.887,1.421-2.783a3.16,3.16,0,0,0,3.014.927,11.458,11.458,0,0,0,1.827,2.368c.686.495,3.755.317,3.967,2.311",
    transform: "translate(20.455 237.576)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309831",
    "data-name": "Path 309831",
    d: "M36.047,118.035c-.355-2.182-4.885-10.95-4.885-10.95s-2.863-.855-4.75-.174-11.637-4.822-11.948-5.331S8.927,91.341,8.927,91.341a1.206,1.206,0,0,0-1.127.112,1.268,1.268,0,0,0-.689,1.055s4.032,12.254,5.1,14.15c.646,1.144,6.083,5.122,10.3,8.1a2.646,2.646,0,0,1,1.1,2.517c-.566,4.19-.709,6.549-1.361,13.741-.541,5.963-.749,17.514-.749,17.514a39.1,39.1,0,0,0,7.973,1.847c3.257.217,3.967-3.214,3.967-3.214s2.974-26.885,2.608-29.13",
    transform: "translate(13.225 169.72)",
    fill: "#626366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309832",
    "data-name": "Path 309832",
    d: "M16.9,95.426a2.793,2.793,0,0,0,1.656.312c.615-.091.755-.821.755-.821a2.426,2.426,0,0,0-1.11,0,4.759,4.759,0,0,0-1.3.506",
    transform: "translate(31.437 176.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309833",
    "data-name": "Path 309833",
    d: "M119.975,21.1s-5.625-10,0-12.028,8.171-.16,8.436,2.119-2.142,11.248-2.142,11.248Z",
    transform: "translate(218.482 15.245)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309834",
    "data-name": "Path 309834",
    d: "M172.312,78.281a182.12,182.12,0,0,1-28.195,2.9,157.764,157.764,0,0,1-21.672-.975q-2.557-.3-4.913-.655c-16.6-2.517-25.773-6.984-25.773-6.984s15.171-31.755,27.426-30.537c14.379,1.433,38.742,14.336,41.164,10.716,2.725-4.075,5.008-39.039,5.008-39.039,6.377-4.367,10.184.235,10.184.235s12.452,61.515-3.229,64.343",
    transform: "translate(170.655 21.987)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309835",
    "data-name": "Path 309835",
    d: "M154.816,46.411a182.122,182.122,0,0,1-28.195,2.9,157.765,157.765,0,0,1-21.672-.975c-3.826-12.169-6.578-24.594,1.115-17.1,13.573,13.215,48.751,15.18,48.751,15.18",
    transform: "translate(188.151 53.858)",
    fill: "#febe6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309836",
    "data-name": "Path 309836",
    d: "M91.5,127.9s-1.092,12.623,1.579,13.939l34.152-.071s0-3.941-5.485-4.816-15.123-4.087-16.753-11.242S91.5,127.9,91.5,127.9",
    transform: "translate(169.762 228.781)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309837",
    "data-name": "Path 309837",
    d: "M128.363,97.01c-.169,8.256-.566,16.77-1.341,24.423-3.689,36.314-4.985,80.189-5.517,88.649-.918,14.682-3.818,38.141-3.818,38.141s-5.754,5.462-16.97,2.857c0,0-9.292-33.789-11.368-69.365l-.094-1.756c-.24-4.7-.492-10.084-.749-15.883-1.71-38.845-3.566-96.55-3.566-96.55L127.8,57.464s.987,18.966.566,39.546",
    transform: "translate(157.971 106.873)",
    fill: "#68686b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309838",
    "data-name": "Path 309838",
    d: "M128.363,97.01C117.5,115.75,96.8,150.274,88.505,164.075c-1.71-38.845-3.566-96.55-3.566-96.55L127.8,57.464s.987,18.966.566,39.546",
    transform: "translate(157.971 106.873)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309839",
    "data-name": "Path 309839",
    d: "M67.979,58.6s-6.972,8.2-7.6,10.476S58.633,79.54,59.231,82s5.236-6.866,6.921-7.862-1.264,3.709-.689,4.5,3.907-2.748,5.208-3.944,1.17-7.627,2.728-11.431S67.979,58.6,67.979,58.6",
    transform: "translate(109.842 108.982)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309840",
    "data-name": "Path 309840",
    d: "M64.888,121.413s-6.08,5.548-4.893,9.489,6.672,6.569,7.413,11.388,3.706,7.444,6.377,7.444h12.72s1.965-3.389-2.78-4.413-6.532-6.681-6.234-11.937a92.891,92.891,0,0,0-.446-12.263l-10.081-2.336Z",
    transform: "translate(111.294 220.919)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309841",
    "data-name": "Path 309841",
    d: "M164.439,69.773s-40.12,85.84-61.469,123.5S74.95,241.451,74.95,241.451s-12.231-4.816-13.344-8.1c0,0,8.165-72.711,22.461-90.436,8.079-10.018,17.571-40.075,18.014-50.585s9.818-35.6,9.818-35.6Z",
    transform: "translate(114.576 105.506)",
    fill: "#68686b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309842",
    "data-name": "Path 309842",
    d: "M148.24,143.68a69.512,69.512,0,0,1-38.533,9.675c-9.912-.432-29.568-3.24-32.742-11.122-.744-1.85-.2-4.2.921-7.8,2.9-9.366,9.658-27.205,7.619-66.757a64.542,64.542,0,0,1,.266-10.381C87.9,37.809,99.06,26.27,109.853,22.5c26.316-9.2,35.09,3.546,35.09,3.546s11.634,9.217,13.387,28.45c3.506,38.476-10.089,89.184-10.089,89.184",
    transform: "translate(142.506 35.645)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309843",
    "data-name": "Path 309843",
    d: "M90.939,35.415s12.077,7.344,25.175,5.268c0,0,2.588-.658,1.316-3.7a38.838,38.838,0,0,0,1.161-4.055,61.447,61.447,0,0,0,1.5-6.618L112.659,18.5l-7.041-7.464c-1.945,17.842-14.679,24.38-14.679,24.38",
    transform: "translate(169.13 20.523)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309844",
    "data-name": "Path 309844",
    d: "M95.678,13.4s4.044,10.816,14.1,15.128c1.147-4.192,1.9-8.585,1.9-8.585l-7.83-5.843Z",
    transform: "translate(177.944 24.922)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309845",
    "data-name": "Path 309845",
    d: "M121.241,40.754s-23.05,2.88-24.669-11.285S90.889,6.139,105.537,3.7s18.131,2.651,19.839,7.253,1.819,28.687-4.135,29.8",
    transform: "translate(176.321 5.704)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309846",
    "data-name": "Path 309846",
    d: "M94.008,7.1c-.2-.246-.672-.455-1.736-.552a4.361,4.361,0,0,1,2.016-.489c.277-1.473,1.167-4.072,3.746-4.613a3.209,3.209,0,0,0-1.642,2.251c3.074-2.926,9.5-4.9,27-2.848,23.07,2.7,14.885,17.228,11.823,18.875S124.8,16.251,119.2,16.482s-6.964,8.256-8.9,9.292-1.115-.9-3.635-2.148-2.92,2.98-2.285,5.768-3.023,6.292-3.023,6.292l-3.412-3.964c-3.412-3.964-6.151-20.316-4.4-23.717.154-.3.309-.6.466-.909",
    transform: "translate(171.609 0.002)",
    fill: "#5a5b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309847",
    "data-name": "Path 309847",
    d: "M143.117,15.956l-39.131.349-.269-5.888,39.011-3.023Z",
    transform: "translate(192.896 13.752)",
    fill: "#68686b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309848",
    "data-name": "Path 309848",
    d: "M155.847,19.432l-42.606.615-.486-10.7,42.486-3.292Z",
    transform: "translate(209.705 11.259)",
    fill: "#68686b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309849",
    "data-name": "Path 309849",
    d: "M161.66,22.51l-35.928.046L125.077,8.1l35.782-3.254Z",
    transform: "translate(232.621 9.021)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309850",
    "data-name": "Path 309850",
    d: "M139.961,26.561h0a2.009,2.009,0,0,0,1.916-2.1L141.034,5.9a2.008,2.008,0,1,0-4.012.183l.841,18.56a2.009,2.009,0,0,0,2.1,1.916",
    transform: "translate(254.831 7.408)",
    fill: "#56575a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309851",
    "data-name": "Path 309851",
    d: "M105.125,16.4h0a1.784,1.784,0,0,1-1.865-1.7l-.22-4.819a1.786,1.786,0,0,1,3.569-.16l.217,4.816a1.786,1.786,0,0,1-1.7,1.865",
    transform: "translate(191.633 14.909)",
    fill: "#68686b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309852",
    "data-name": "Path 309852",
    d: "M77.065,109.662c2.9-9.369,9.66-27.205,7.619-66.76a64.848,64.848,0,0,1,.266-10.378h0c8.66-.744,21.9,8.62,21.9,8.62S98.7,90.853,77.065,109.662",
    transform: "translate(143.327 60.411)",
    fill: "#febe6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309853",
    "data-name": "Path 309853",
    d: "M146.248,19.56s-22.209,3.818-33.792,17.957S82.24,71.6,77.836,78.581s-16.636,54.5-16.636,54.5.806,1.53,4.181,2.417a7.952,7.952,0,0,0,5.571-.466s16.2-27.732,22.3-41.585c2.534-5.754,46.349-28.55,62.825-26.187,6.469.929-9.829-47.7-9.829-47.7",
    transform: "translate(113.821 36.378)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309854",
    "data-name": "Path 309854",
    d: "M117.413,7.826s4.776,2.923,7.633,1.684,2.605-2.368,2.605-2.368-8.631-2.394-10.238.683",
    transform: "translate(218.367 11.635)",
    fill: "#fedaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309855",
    "data-name": "Path 309855",
    d: "M154.683,25.683s-9.746,61.532-78.9,79.449l-7.533,14.862,13.232,2.239S160.211,99.426,159.152,24.6Z",
    transform: "translate(126.938 45.744)",
    fill: "#fda02a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309856",
    "data-name": "Path 309856",
    d: "M100.022,21.542l-3.192.312v4.621l4.7,4.887L106,30.276V23.864l-3.214-2.322Z",
    transform: "translate(180.087 40.064)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309857",
    "data-name": "Path 309857",
    d: "M100.169,17.263s-3.089.7-10.152,6.566c0,0,7.024,14.911,21.846,16.7,0,0-.24-6.921.832-11.027,0,0-11.748-4.207-12.526-12.237",
    transform: "translate(167.416 32.106)",
    fill: "#febe6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309858",
    "data-name": "Path 309858",
    d: "M97.947,24.209s7.232,3.841,7.764,9.821c0,0,2.768-4.378,1.968-7.413a24.814,24.814,0,0,0-3.283-6.509s.246,3.655-6.449,4.1",
    transform: "translate(182.164 37.397)",
    fill: "#febe6e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg62PlacementSupport);
export default __webpack_public_path__ + "static/media/6.2_Placement_Support.fd45862f5c53b35d32ab024edb5275a8.svg";
export { ForwardRef as ReactComponent };